import { render, staticRenderFns } from "./Addthemesize.vue?vue&type=template&id=5cdd5e00&scoped=true"
import script from "./Addthemesize.vue?vue&type=script&lang=js"
export * from "./Addthemesize.vue?vue&type=script&lang=js"
import style0 from "./Addthemesize.vue?vue&type=style&index=0&id=5cdd5e00&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cdd5e00",
  null
  
)

export default component.exports